"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const BaseAPIService_1 = require("./BaseAPIService");
const Services_1 = require("./Services");
class TicketService extends BaseAPIService_1.default {
    constructor(baseURL, token) {
        super(baseURL, 'ticket', token);
    }
    porting() {
        return new Services_1.PortingTicketService(this.baseURL, this.token);
    }
    allocation() {
        return new Services_1.AllocationTicketService(this.baseURL, this.token);
    }
    export() {
        return new Services_1.ExportTicketService(this.baseURL, this.token);
    }
    migration() {
        return new Services_1.MigrationTicketService(this.baseURL, this.token);
    }
    globalNumber() {
        return new Services_1.GlobalNumberTicketService(this.baseURL, this.token);
    }
    assignment() {
        return new __1.AssignmentTicketService(this.baseURL, this.token);
    }
    email(id) {
        return new Services_1.TicketEmailService(this.baseURL, this.token, id);
    }
    status(id) {
        return new Services_1.TicketStatusService(this.baseURL, this.token, id);
    }
    productTable(id) {
        return new Services_1.TicketProductTableService(this.baseURL, this.token, id);
    }
    comment(id) {
        return new Services_1.TicketCommentService(this.baseURL, this.token, id);
    }
    note(id) {
        return new Services_1.TicketNoteService(this.baseURL, this.token, id);
    }
    charge(id) {
        return new __1.TicketChargeService(this.baseURL, this.token, id);
    }
}
exports.default = TicketService;
